const lt = {
  brand: "E2 Care",
  tagline: "Rami, susieta priežiūra.",
  nav_dashboard: "Skydelis",
  nav_residents: "Pacientai",
  nav_patients: "Pacientai",
  nav_rooms: "Kambariai",
  nav_devices: "Įrenginiai",
  nav_events: "Įvykiai",
  nav_alerts: "Įspėjimai",
  nav_users: "Komanda",
  nav_settings: "Nustatymai",
  nav_admin: "Administravimas",
  nav_signout: "Atsijungti",
  topbar_search_placeholder: "Ieškoti pacientų, kambarių, įrenginių…",
  admin_super_only: "Tik super-administratoriai gali valdyti organizacijas.",
  admin_admin_only: "Šiame puslapyje gali dirbti tik administratoriai.",
  admin_tab_orgs: "Organizacijos",
  admin_tab_users: "Vartotojai",
  admin_tab_patients: "Pacientai",
  admin_tab_rooms: "Kambariai",
  admin_tab_buildings: "Pastatai",
  admin_tab_devices: "Įrenginiai",
  admin_tab_alerts: "Įspėjimai",
  admin_tab_qa: "Testavimo įrankiai",
  admin_delete: "Ištrinti",
  admin_no_orgs_yet: "Organizacijų dar nėra.",
  admin_field_name: "Pavadinimas",
  admin_field_email: "El. paštas",
  admin_field_phone: "Telefonas",
  admin_field_password: "Slaptažodis",
  admin_field_role: "Vaidmuo",
  admin_field_type: "Tipas",
  admin_field_timezone: "Laiko juosta",
  admin_field_address: "Adresas",
  admin_field_status: "Būsena",
  admin_field_organization: "Organizacija",
  admin_password_keep: "Palikti tuščią, kad išliktų",
  admin_field_birth_date: "Gimimo data",
  admin_field_room: "Kambarys",
  admin_field_room_none: "Nepriskirta",
  admin_field_photo: "Nuotraukos URL",
  admin_field_photo_hint: "Įklijuokite viešą URL — pilnas įkėlimas v2.",
  admin_field_notes: "Priežiūros pastabos",
  admin_field_emergency_contact: "Pagrindinis avarinis kontaktas",
  admin_field_ec_name: "Vardas",
  admin_field_ec_phone: "Telefonas",
  admin_field_ec_relationship: "Ryšys",
  admin_field_mac: "MAC adresas",
  admin_field_firmware: "Programinė įranga",
  admin_field_assignment: "Priskirtas",
  admin_field_assigned_room: "Priskirtas kambarys",
  admin_field_assigned_patient: "Priskirtas pacientas",
  admin_field_assigned_hint: "Pasirinktinai. Davikliai → kambarys; apyrankės → pacientas.",
  admin_field_sensor_target: "Pritvirtinta prie",
  admin_field_sensor_target_hint: "Nurodo sistemai, ar šis jutiklis stebi duris, ar langą.",
  sensor_target_door: "Durys",
  sensor_target_window: "Langas",
  sensor_target_unset: "Nesukonfigūruota",
  admin_field_sensor_label: "Jutiklio žymė",
  admin_field_sensor_label_hint: "Patogus pavadinimas, rodomas įspėjimuose ir įvykiuose — pvz. „Priekinės durys“, „Vonios langas“.",
  admin_field_building: "Pastatas",
  admin_field_building_required: "Kambarys turi priklausyti pastatui.",
  room_openings: "Angos",
  room_no_openings: "Šiame kambaryje dar neįrengta durų ar langų jutiklių.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Paskutinis pokytis",
  admin_field_description: "Aprašymas",
  admin_field_severity: "Sunkumas",
  admin_field_patient: "Pacientas",
  admin_field_device: "Įrenginys",
  admin_field_message: "Pranešimas",
  admin_orgs_title: "Organizacijos",
  admin_orgs_sub: "Kurkite, redaguokite ir archyvuokite E2 Care nuomininkus.",
  admin_orgs_count: "organizacijos",
  admin_org_new: "Nauja organizacija",
  admin_org_new_title: "Nauja organizacija",
  admin_org_edit_title: "Redaguoti organizaciją",
  admin_org_created: "Organizacija sukurta.",
  admin_org_updated: "Organizacija atnaujinta.",
  admin_org_deleted: "Organizacija archyvuota.",
  admin_org_delete_title: "Archyvuoti organizaciją?",
  admin_org_delete_confirm: "«{name}» bus paslėpta nuo sąrašų.",
  admin_users_title: "Vartotojai",
  admin_users_sub_super: "Tvarkykite visus vartotojų paskyras visuose nuomininkuose.",
  admin_users_sub_org: "Tvarkykite {org} vartotojų paskyras.",
  admin_user_new: "Naujas vartotojas",
  admin_user_new_title: "Naujas vartotojas",
  admin_user_edit_title: "Redaguoti vartotoją",
  admin_user_created: "Vartotojas sukurtas.",
  admin_user_updated: "Vartotojas atnaujintas.",
  admin_user_deleted: "Vartotojas archyvuotas.",
  admin_user_delete_title: "Archyvuoti vartotoją?",
  admin_user_delete_confirm: "«{name}» praras prieigą.",
  admin_user_memberships: "Organizacijos narystės",
  admin_patients_title: "Pacientai",
  admin_patients_sub_super: "Tvarkykite visus pacientus visuose nuomininkuose.",
  admin_patients_sub_org: "Tvarkykite pacientus {org}.",
  admin_patient_new: "Naujas pacientas",
  admin_patient_new_title: "Naujas pacientas",
  admin_patient_edit_title: "Redaguoti pacientą",
  admin_patient_created: "Pacientas sukurtas.",
  admin_patient_updated: "Pacientas atnaujintas.",
  admin_patient_deleted: "Pacientas archyvuotas.",
  admin_patient_delete_title: "Archyvuoti pacientą?",
  admin_patient_delete_confirm: "«{name}» bus paslėptas nuo sąrašų.",
  admin_rooms_title: "Kambariai",
  admin_rooms_sub_super: "Konfigūruokite kambarius visuose nuomininkuose.",
  admin_rooms_sub_org: "Konfigūruokite kambarius {org}.",
  admin_room_new: "Naujas kambarys",
  admin_room_new_title: "Naujas kambarys",
  admin_room_edit_title: "Redaguoti kambarį",
  admin_room_created: "Kambarys sukurtas.",
  admin_room_updated: "Kambarys atnaujintas.",
  admin_room_deleted: "Kambarys archyvuotas.",
  admin_room_delete_title: "Archyvuoti kambarį?",
  admin_room_delete_confirm: "«{name}» bus paslėptas.",
  admin_devices_title: "Įrenginiai",
  admin_devices_sub_super: "Aprūpinkite Moko įrenginius visuose nuomininkuose.",
  admin_devices_sub_org: "Aprūpinkite Moko įrenginius {org}.",
  admin_device_new: "Naujas įrenginys",
  admin_device_new_title: "Naujas įrenginys",
  admin_device_edit_title: "Redaguoti įrenginį",
  admin_device_created: "Įrenginys sukurtas.",
  admin_device_updated: "Įrenginys atnaujintas.",
  admin_device_deleted: "Įrenginys archyvuotas.",
  admin_device_delete_title: "Archyvuoti įrenginį?",
  admin_device_delete_confirm: "Įrenginys {mac} bus paslėptas.",
  admin_buildings_title: "Pastatai",
  admin_buildings_sub_super: "Sugrupuokite kambarius pagal pastatą / sparną visuose nuomininkuose.",
  admin_buildings_sub_org: "Sugrupuokite kambarius pagal pastatą / sparną {org}.",
  admin_building_new: "Naujas pastatas",
  admin_building_new_title: "Naujas pastatas",
  admin_building_edit_title: "Redaguoti pastatą",
  admin_building_created: "Pastatas sukurtas.",
  admin_building_updated: "Pastatas atnaujintas.",
  admin_building_deleted: "Pastatas archyvuotas.",
  admin_building_delete_title: "Archyvuoti pastatą?",
  admin_building_delete_confirm: "«{name}» bus paslėptas.",
  admin_qa_title: "Testavimo įrankiai",
  admin_qa_sub: "Įveskite įvykius / įspėjimus testavimui be realios Moko įrangos.",
  admin_qa_event_title: "Įvesti testinį įvykį",
  admin_qa_event_sub: "Imituoja Moko webhook.",
  admin_qa_alert_title: "Įvesti testinį įspėjimą",
  admin_qa_alert_sub: "Praleidžia įvykių sluoksnį ir rašo įspėjimą tiesiogiai.",
  admin_qa_inject_event: "Įvesti įvykį",
  admin_qa_inject_alert: "Įvesti įspėjimą",
  admin_qa_event_done: "Įvykis įvestas.",
  admin_qa_alert_done: "Įspėjimas įvestas.",
  admin_qa_disclaimer: "Šie galiniai taškai turi būti išjungti gamyboje.",
  admin_alerts_title: "Įspėjimų politika",
  admin_alerts_sub: "Visos {org} įspėjimų taisyklės. Taikomos kiekvienam šio nuomininko pacientui.",
  admin_alerts_quiet_title: "Tylos valandos",
  admin_alerts_quiet_desc: "Nustatykite, kada ši organizacija veikia „nakties režimu“. Naudinga tyliau nukreipti nekritinius įspėjimus.",
  admin_alerts_quiet_hint: "Laikas interpretuojamas pagal vietinę organizacijos laiko juostą. Intervalas gali peržengti vidurnaktį (pvz. 22:00 → 06:00).",
  admin_alerts_night_start: "Naktis prasideda",
  admin_alerts_night_end: "Naktis baigiasi",
  admin_alerts_load_failed: "Įkelti įspėjimų politiką",
  admin_alerts_save_failed: "Įrašyti įspėjimų politiką",
  admin_alerts_saved: "Įspėjimų politika įrašyta.",
  admin_alerts_clear_title: "Išvalyti aktyvius įspėjimus",
  admin_alerts_clear_desc: "Vienu paspaudimu patvirtinkite visus šios organizacijos atvirus įspėjimus.",
  admin_alerts_clear_hint: "Naudinga po suplanuotų pratybų ar netinkamai sukonfigūruoto jutiklio, sukėlusio klaidingų signalų bangą. Patvirtinti įspėjimai lieka istorijoje.",
  admin_alerts_ack_all_button: "Patvirtinti visus",
  admin_alerts_ack_all_title: "Patvirtinti visus aktyvius įspėjimus?",
  admin_alerts_ack_all_confirm: "Tai pažymės kaip patvirtintą kiekvieną atvirą įspėjimą organizacijoje {org}. Šio veiksmo atšaukti negalima.",
  admin_alerts_ack_all_done: "{count} įspėjimas(-ai) patvirtinta.",
  admin_alerts_ack_all_done_generic: "Visi aktyvūs įspėjimai patvirtinti.",
  admin_alerts_ack_all_failed: "Patvirtinti visus įspėjimus",
  org_type_nursing_home: "Slaugos namai",
  org_type_assisted_living: "Globos namai",
  org_type_hospital: "Ligoninė",
  org_type_home_care: "Priežiūra namuose",
  role_admin: "Administratorius",
  role_caregiver: "Slaugytojas",
  role_family: "Šeima",
  status_active: "aktyvus",
  status_inactive: "neaktyvus",
  confirm: "Patvirtinti",
  sign_in: "Prisijungti",
  sign_up: "Registruotis",
  email: "El. paštas",
  password: "Slaptažodis",
  full_name: "Pilnas vardas",
  create_account: "Sukurti paskyrą",
  no_account: "Dar neturite paskyros?",
  have_account: "Jau turite paskyrą?",
  login_welcome: "Sveiki sugrįžę",
  login_sub: "Prisijunkite, kad galėtumėte toliau stebėti savo gyventojus.",
  register_welcome: "Prisijunkite prie E2 Care",
  register_sub: "Sukurkite savo darbo vietą per mažiau nei minutę.",
  total_residents: "Pacientai",
  active_devices: "Aktyvūs įrenginiai",
  open_alerts: "Atviri įspėjimai",
  offline_gateways: "Atjungti įrenginiai",
  falls_7d: "Kritimai (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Silpna baterija",
  critical_residents: "Kritiški",
  status_ok: "Viskas gerai",
  status_warning: "Dėmesio",
  status_critical: "Kritiška",
  status_online: "Prisijungęs",
  status_offline: "Atjungtas",
  search: "Ieškoti",
  filter: "Filtruoti",
  all: "Visi",
  refresh: "Atnaujinti",
  loading: "Įkeliama…",
  no_results: "Čia dar nieko nėra.",
  view_profile: "Žiūrėti profilį",
  showing_n_of_m: "Rodoma {n} iš {m}",
  load_more: "Įkelti daugiau",
  auto_refresh: "Tiesiogiai · auto atnaujinimas",
  auto_refresh_paused: "Pristabdyta (įkelti daugiau aktyvu)",
  updated_just_now: "Atnaujinta dabar",
  updated_n_sec_ago: "Atnaujinta prieš {n}s",
  updated_n_min_ago: "Atnaujinta prieš {n}m",
  acknowledge: "Patvirtinti",
  acknowledged: "Patvirtinta",
  ack_all: "Patvirtinti visus",
  ack_all_confirm: "Patvirtinti visus {count} aktyvius įspėjimus?",
  ack_all_running: "Patvirtinama…",
  ack_all_done: "{count} įspėjimas(-ai) patvirtinta.",
  ack_all_partial: "{ok} patvirtinta · {fail} nepavyko.",
  last_seen: "Paskutinį kartą matytas",
  battery: "Baterija",
  signal: "Signalas",
  firmware: "Programinė įranga",
  room: "But. / Kamb.",
  age: "Amžius",
  emergency_contact: "Avarinis kontaktas",
  notes: "Pastabos",
  assigned_devices: "Priskirti įrenginiai",
  recent_events: "Naujausi įvykiai",
  timeline_24h: "Paskutinės 24 val.",
  delivery_status: "Pristatymo būsena",
  acknowledged_by: "Patvirtino",
  dashboard_title: "Apžvalga",
  dashboard_sub: "Greita visko, kas vyksta jūsų prižiūrimuose namuose, apžvalga.",
  residents_title: "Pacientai",
  residents_sub: "Žmonės, kuriuos šiuo metu stebite.",
  devices_title: "Įrenginiai",
  devices_sub: "Davikliai ir apyrankės.",
  devices_sub_admin: "Šliuzai, davikliai ir apyrankės.",
  events_title: "Tiesioginiai įvykiai",
  events_sub: "Chronologinis srautas iš kiekvieno prijungto įrenginio.",
  alerts_title: "Įspėjimai",
  alerts_sub: "Pranešimai, perduoti šeimai ir slaugytojams.",
  settings_title: "Nustatymai",
  settings_sub: "Jūsų nuostatos ir pranešimų taisyklės.",
  users_title: "Komanda",
  users_sub: "Slaugytojai, šeima ir administratoriai su prieiga.",
  falls_chart_title: "Kritimai ir SOS — paskutinės 7 dienos",
  recent_alerts_title: "Naujausi kritiški įspėjimai",
  no_alerts: "Nėra atvirų įspėjimų. Visi saugūs.",
  event_fall: "Aptiktas kritimas",
  event_sos: "Paspaustas SOS mygtukas",
  event_door_open: "Atidarytos durys",
  event_door_close: "Uždarytos durys",
  event_inactivity: "Ilgalaikis neveiklumas",
  event_low_battery: "Silpna baterija",
  event_offline: "Įrenginys atjungtas",
  event_online: "Įrenginys vėl prisijungęs",
  event_heartbeat: "Širdies plakimas",
  event_button_press: "Paspaustas mygtukas",
  device_gateway: "Bluetooth šliuzas",
  device_door_sensor: "Durų daviklis",
  device_bracelet: "Apyrankė",
  device_unknown: "Nežinomas įrenginys",
  language: "Kalba",
  notifications: "Pranešimai",
  quiet_hours: "Tylos valandos",
  escalation: "Eskalavimo politika",
  just_now: "ką tik",
  min_ago: "min",
  h_ago: "val.",
  d_ago: "d.",
  demo_hint: "Demo paskyra: admin@e2care.lv / Care2024!",
  open_menu: "Atidaryti meniu",
  close_menu: "Uždaryti meniu",
  care_team: "Priežiūros komanda",
  family_members: "Šeima",
  no_caregivers: "Slaugytojų dar nepriskirta.",
  no_family: "Šeimos narių dar nesusieta.",
  add_caregiver: "Pridėti slaugytoją",
  add_family: "Pridėti šeimos narį",
  select_user: "Pasirinkite vartotoją…",
  cancel: "Atšaukti",
  add: "Pridėti",
  remove: "Pašalinti",
  save: "Išsaugoti",
  relationship: "Giminystė",
  relationship_son: "Sūnus",
  relationship_daughter: "Dukra",
  relationship_spouse: "Sutuoktinis",
  relationship_other: "Kita",
  notify_via: "Pranešti per",
  call_contact: "Skambinti",
  view_resident: "Atidaryti profilį",
  address: "Adresas",
  admin_only_section: "Administratoriaus įrankiai",
  rooms_title: "Kambariai",
  rooms_sub: "Kiekvienas prižiūrimas kambarys — pacientai, įrenginiai ir dabartinė būsena.",
  room_name: "Kambarys",
  room_type: "Tipas",
  room_type_private_room: "Privatus kambarys",
  room_type_shared_room: "Bendras kambarys",
  room_type_apartment: "Butas",
  room_type_corridor: "Koridorius",
  room_type_common_area: "Bendra erdvė",
  room_floor: "Aukštas",
  room_state: "Dabartinė būsena",
  door: "Durys",
  window: "Langas",
  door_open_state: "Atidarytos",
  door_closed_state: "Uždarytos",
  door_unknown_state: "Nežinoma",
  room_no_devices: "Šiame kambaryje dar nėra įrenginių.",
  room_no_patients: "Šiam kambariui dar nepriskirta pacientų.",
  room_patients: "Pacientai kambaryje",
  room_devices: "Įrenginiai kambaryje",
  room_activity: "Veiklos chronologija",
  rooms_filter_all_types: "Visi tipai",
  widget_active_alerts: "Aktyvūs įspėjimai",
  widget_active_alerts_sub: "Kritiški, neišspręsti ir patvirtinti",
  widget_patients_status: "Pacientų būsena",
  widget_devices_health: "Įrenginių būklė",
  widget_room_activity: "Kambarių veikla",
  widget_recent_events: "Tiesioginių įvykių srautas",
  widget_connectivity: "Ryšys",
  metric_critical: "Kritiška",
  metric_unresolved: "Neišspręsta",
  metric_acknowledged_count: "Patvirtinti",
  metric_total: "Iš viso",
  metric_active: "Aktyvūs",
  metric_online: "Prisijungęs",
  metric_offline: "Atjungtas",
  metric_ota_pending: "OTA laukia",
  metric_battery_warn: "Silpna baterija",
  metric_doors_open: "Atidarytos durys",
  metric_windows_open: "Atidaryti langai",
  metric_signal_avg: "Vid. signalas",
  metric_last_comm: "Pask. ryšys",
  metric_packets: "Paketų / val.",
  view_all: "Žiūrėti visus",
  status_new: "Naujas",
  status_acknowledged: "Patvirtintas",
  status_resolved: "Išspręstas",
  status_resolved_local: "Išspręsta (vietinė)",
  resolve: "Išspręsti",
  add_note: "Pridėti pastabą",
  save_note: "Išsaugoti pastabą",
  resolve_local_badge: "tik šiame įrenginyje",
  resolve_local_hint: "Pažymi įspėjimą kaip išspręstą tik jūsų naršyklėje. Serveris ir kiti komandos nariai vis dar mato jį kaip atvirą.",
  note_placeholder: "Pridėkite konteksto komandai…",
  notes_count: "{n} pastabų",
  device_detail: "Įrenginio detalė",
  device_diagnostics: "Diagnostika",
  device_firmware_history: "Programinės įrangos istorija",
  device_ota_config: "OTA konfigūracija",
  device_ota_status: "OTA būsena",
  device_signal: "Signalo kokybė",
  device_mac: "MAC adresas",
  device_serial: "Serijos numeris",
  fall_sensitivity: "Kritimo jautrumas",
  transmission_interval: "Perdavimo intervalas",
  low_battery_threshold: "Žemos baterijos slenkstis",
  ota_idle: "Neveiklus",
  ota_pending: "Laukia",
  ota_deploying: "Diegiamas",
  ota_failed: "Nepavyko",
  events_filter_severity: "Sunkumas",
  events_filter_room: "Kambarys",
  events_filter_patient: "Pacientas",
  events_filter_device: "Įrenginys",
  severity_info: "Info",
  severity_warning: "Įspėjimas",
  severity_critical: "Kritiška",
  telegram_title: "Telegram įspėjimai",
  telegram_desc: "Gaukite Telegram įspėjimus apie jums priskirtus gyventojus.",
  telegram_connect: "Prijungti Telegram",
  telegram_connected: "Telegram prijungtas",
  telegram_connected_as: "Prijungta prie Telegram kaip {name}",
  telegram_connect_success: "Telegram sėkmingai prijungtas",
  telegram_connect_error: "Nepavyko prijungti Telegram. Bandykite dar kartą.",
  telegram_missing_bot: "Telegram botas nesukonfigūruotas. Nustatykite REACT_APP_TELEGRAM_BOT env faile.",
  telegram_disconnect: "Atjungti",
  telegram_disconnect_success: "Telegram atjungtas.",
  telegram_disconnect_error: "Nepavyko atjungti Telegram. Bandykite dar kartą.",
  telegram_already_linked: "Ši Telegram paskyra jau susieta su kitu e2-care naudotoju.",
  telegram_switch_q: "Naudoti kitą Telegram paskyrą?",
  telegram_switch_intro: "Telegram įsimena, kuri paskyra prisijungusi visose svetainėse. Norėdami naudoti kitą:",
  telegram_switch_step1: "Atidarykite Telegram Web ir atsijunkite nuo dabartinės paskyros.",
  telegram_switch_step2: "Grįžkite čia ir iš naujo įkelkite žemiau esantį mygtuką, tada prisijunkite su kita paskyra.",
  telegram_open_web: "Atidaryti Telegram Web",
  telegram_reload_widget: "Atsijungiau — įkelti mygtuką iš naujo",
  lang_autodetected_toast: "Aptikta jūsų kalba: {language}. Galite ją pakeisti Nustatymuose.",
  admin_view_active: "Aktyvūs",
  admin_view_archived: "Archyvuoti",
  admin_restore: "Atkurti",
  admin_restored: "Atkurta.",
  admin_hard_delete: "Ištrinti visam laikui",
  admin_hard_delete_title: "Ištrinti visam laikui?",
  admin_hard_delete_confirm: "«{name}» bus visam laikui pašalintas iš duomenų bazės. Šio veiksmo negalima atšaukti.",
  admin_hard_deleted: "Visam laikui ištrintas.",
  admin_no_archived: "Nėra archyvuotų elementų.",
  language_desc: "Naudojama programos sąsajai ir jūsų Telegram + push pranešimams.",
  language_saved: "Kalba atnaujinta.",
  language_error: "Nepavyko atnaujinti kalbos. Bandykite dar kartą.",
  admin_field_language: "Kalba",
  edit: "Redaguoti",
  generic_error: "Kažkas nutiko. Bandykite dar kartą.",
  caregiver_added: "Slaugytojas pridėtas.",
  caregiver_removed: "Slaugytojas pašalintas.",
  family_added: "Šeimos narys pridėtas.",
  family_removed: "Šeimos narys pašalintas.",
  menu: "Meniu",
  dl_companion_app: "Palydovinė programa",
  dl_hero_title: "E2 Care, skirta Android",
  dl_hero_sub: "Įdiekite palydovinę programą į Moko įrenginiu aprūpintą telefoną, kad perduotumėte įspėjimus, konfigūruotumėte įrenginius ir palaikytumėte ryšį su savo priežiūros komanda — net kai skydelis uždarytas.",
  dl_android_apk: "Android APK",
  dl_version_loading: "įkeliama versija…",
  dl_released: "Išleista {date}",
  dl_download_apk: "Atsisiųsti APK",
  dl_unavailable: "Nepasiekiama",
  dl_preparing: "Ruošiama…",
  dl_manifest_error: "Nepavyko įkelti manifesto. Pabandykite atnaujinti — jei problema išlieka, kūrimo serveris gali būti iš naujo diegiamas.",
  dl_whats_new: "Kas naujo",
  dl_installing_title: "Diegimas telefone",
  dl_step1: "Palieskite „Atsisiųsti APK“ viršuje. Jūsų naršyklė gali įspėti, kad APK failai gali pakenkti įrenginiui — šis įspėjimas įprastas bet kuriam ne iš Play Store atsisiųstam diegimo failui.",
  dl_step2: "Atidarykite atsisiųstą failą. Android pirmą kartą paprašys leisti diegti iš šios naršyklės — įjunkite leidimą ir grįžkite.",
  dl_step3: "Palieskite „Įdiegti“, tada „Atidaryti“, kai baigsis.",
  dl_step4: "Prisijunkite naudodami savo E2 Care prisijungimo duomenis.",
  dl_iphone_note: "iPhone versija bus vėliau. Kol kas naudokite žiniatinklio skydelį.",
  dl_back_to_dashboard: "Grįžti į skydelį",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Pakeitus organizaciją, dabartinis kambario ir paciento priskyrimas išvalomas.",
  admin_view_full: "Visas sąrašas",
  device_filter_assignment: "Priskyrimas",
  device_filter_patient: "Priskirta pacientui",
  device_filter_room: "Priskirta kambariui",
  device_filter_unassigned: "Nepriskirta",
  admin_all_orgs: "Visos organizacijos",
  pagination_prev: "Ankstesnis",
  pagination_next: "Kitas",
  pagination_per_page: "Puslapyje",
  pagination_page_of: "Puslapis {page} iš {pages}",
  pagination_total: "Iš viso {total}",
};
export default lt;
